import React from 'react';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import SessionStorage from '@vantiva-sa/homesight_humaui/Utilities/SessionStorage';
import { AppStorageKeys } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { HomeSightNewLogo } from '../Common/Icons';
import { NewRedirectIcon } from '../Common/Icons';
import { hasOnlyStaffAdminPrivileges } from '../DeviceInventory/helpers';
const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);

const AboutCardInfo = () => {
  const { protocol, hostname } = window.location;
  const hostURL = protocol + '//' + hostname;
  const trans = useSelector(translator);
  const currentUser = useSelector(getCurrentUser);
  return (
    <>
      <div className="help-page-card-header">{trans('ABOUT')}</div>
      <HomeSightNewLogo />
      <div className="help-page-about-data-container">
        {hasOnlyStaffAdminPrivileges(currentUser?.permission_level) && (
          <div className="help-page-card-data-group">
            <a
              href={hostURL}
              target="_self"
              style={{ color: '#3FA9F5', textDecoration: 'underline' }}
              className="help-page-data-label"
            >
              {trans('VIEW_DASHBOARD')}
            </a>
            <NewRedirectIcon />
          </div>
        )}
        <div>
          <p className="help-page-about-data version">
            {trans('CAREPORTALVERSION')} {ENV_VARS.VERSION}
          </p>
        </div>
        <div>
          <span className="help-page-about-data copyright">{trans('COPYWRITETEXT')}</span>
        </div>
      </div>
    </>
  );
};

export default AboutCardInfo;
